<template>

  <div :class="{
    'header-wrapper':true,
    'uk-section-xsmall':true,
    'section-transparent': !data.dark,
    'uk-section-primary': !(!data.dark),
  }">
    <h1 class="uk-margin-small-bottom">{{ data.header }}</h1>
    <h3 class="uk-text-muted uk-margin-remove" v-if="data.subheader">{{ data.subheader }}</h3>
  </div>

</template>

<script>
	export default {
		name: 'Header',
    props: ["data"]
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../node_modules/uikit/src/less/uikit.less";
@import "../../assets/less/theme.less";
@import "../../assets/less/custom.less";

  .header-wrapper {

  }

</style>
